module.exports = __webpack_public_path__ + "static/img/kf.6e3c694.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/contact/img/kf.jpg
// module id = iQYN
// module chunks = 1